import { isWindowLoad } from 'utils/routesUtils';

const SUPERADMIN_STATUS = 'isSuperAdmin';
const DIVISION_ID_KEY = 'divisionId';

export const setSuperAdminStatus = (status: string): void => {
  localStorage.setItem(SUPERADMIN_STATUS, status);
};

export const getStorageItem = (key: string): string => localStorage.getItem(key);

export const getIsSuperAdmin = (): string | null => {
  if (!isWindowLoad()) {
    return null;
  }

  return getStorageItem(SUPERADMIN_STATUS);
};

export const setDivisionId = (divisionId: number): void => {
  localStorage.setItem(DIVISION_ID_KEY, divisionId.toString());
};

export const getUrlVars = (): string[] => {
  const vars = [];
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
  });

  return vars;
};

export const getDivisionId = (): number | null => {
  if (!isWindowLoad()) {
    return null;
  }

  // here checking division id in url and setting Division Id.
  getUrlVars()['division_id'] && setDivisionId(getUrlVars()['division_id']);

  return Number(getStorageItem(DIVISION_ID_KEY));
};
